export default {
  header: {
    id: 'battery_modal_header',
    defaultMessage: 'Our battery standards',
  },
  title: {
    id: 'battery_modal_title',
    defaultMessage: 'Everyday, reliable battery performance',
  },
  section1Subtitle: {
    id: 'battery_modal_section_1_subtitle',
    defaultMessage:
      'Battery to get you through a full day without charging on the go',
  },
  section1Body: {
    id: 'battery_modal_section_1_body',
    defaultMessage:
      'We hold every seller to strict battery standards, with testing and/or replacement required, so you get reliable performance from day one. For peace of mind, batteries are also fully covered under your free warranty for 1-year.',
  },
  section2Subtitle: {
    id: 'battery_modal_section_2_subtitle',
    defaultMessage:
      'How long your battery should typically last before charging',
  },
  stat1Number: {
    id: 'battery_modal_stat_1_number',
    defaultMessage: '480',
  },
  stat1Text: {
    id: 'battery_modal_stat_1_text',
    defaultMessage: 'mins of your Madonna roadtrip playlist',
  },
  stat2Number: {
    id: 'battery_modal_stat_2_number',
    defaultMessage: '6',
  },
  stat2Text: {
    id: 'battery_modal_stat_2_text',
    defaultMessage: 'hours of scrolling through cat memes',
  },
  stat3Number: {
    id: 'battery_modal_stat_3_number',
    defaultMessage: '2.5',
  },
  stat3Text: {
    id: 'battery_modal_stat_3_text',
    defaultMessage: 'Bollywood movies on a red eye flight',
  },
  illustrationAlt: {
    id: 'battery_modal_illustration_alt',
    defaultMessage: 'Close-up of a refurbished smartphone battery',
  },
} as const
